import { render } from "./LiveBtnControl.vue?vue&type=template&id=0dc81a18"
import script from "./LiveBtnControl.vue?vue&type=script&lang=js"
export * from "./LiveBtnControl.vue?vue&type=script&lang=js"

import "./LiveBtnControl.vue?vue&type=style&index=0&id=0dc81a18&lang=css"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__